import { render, staticRenderFns } from "./ConfirmCompleteLanguages.vue?vue&type=template&id=d9a60fa8&"
import script from "./ConfirmCompleteLanguages.vue?vue&type=script&lang=js&"
export * from "./ConfirmCompleteLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports